export type Locale = string;

export type EmptyAction<T extends string> = {
  type: T;
};

export type PayloadAction<T extends string, P> = {
  type: T;
  payload: P;
};

export type Store<TState, TActions> = {
  state: TState;
  actions: TActions;
};

export enum ProductType {
  AUTHORIZE = 'authorize',
  PAY = 'pay',
  CREDENTIALS = 'credentials',
  ACCOUNT_CHECK = 'account-check',
  BUSINESS_ACCOUNT_CHECK = 'business-account-check',
  INCOME_CHECK = 'income-check',
  TRANSACTIONS = 'transactions',
  BUSINESS_TRANSACTIONS = 'business-transactions',
  REPORTS = 'reports',
  RISK_INSIGHTS = 'risk-insights',
  EXPENSE_CHECK = 'expense-check',
  PRODUCTS = 'products',
  ANY = 'ANY',
}

export type OmitStrict<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
